<svg:g (click)="clickArea(area)" [innerHTML]="xml() | safe: 'html'"></svg:g>